import apiMiddleware from "../../../api/apiMiddleware";

// list meals with pagination and search
const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `food-master?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};

// create meal
const create = async (mealData) => {
  const response = await apiMiddleware.post("food-master", mealData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// get meal by id
const getById = async (id) => {
  const response = await apiMiddleware.get(`food-master/${id}`);
  return response.data;
};

// update meal
const update = async ({ id, mealData }) => {
  const response = await apiMiddleware.post(`food-master/${id}?_method=PUT`, mealData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// delete meal
const deleteMeal = async (id) => {
  const response = await apiMiddleware.delete(`food-master/${id}`);
  return response.data;
};

// update meal order
const updateOrder = async (orderedMeals) => {
  console.log("Updating meal order:", orderedMeals);
  const response = await apiMiddleware.post(`food-master?_method=PUT`, {
    meals: orderedMeals.map((meal, index) => ({
      id: meal.id,
      order: index + 1,
    })),
  });
  return response.data;
};

// sort meals (same as states)
const sort = async ({ sort_from, sort_to }) => {
  const response = await apiMiddleware.post(`food-master-sort?_method=put`, {
    sort_from,
    sort_to,
  });
  return response.data;
};

export { list, create, getById, update, deleteMeal, updateOrder, sort };
